<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>
          <strong>Онбординги</strong>
        </CCardHeader>
        <CCardBody>
          <div class="table__preloader" v-if="loading">
            <CSpinner color="primary" />
          </div>
          <template v-else>
            <div class="d-flex justify-content-end mb-2">
              <CButton color="primary" @click="$router.push('/onboarding/create')">
                Создать онбординг
              </CButton>
            </div>
            <table class="table table-hover mt-3">
              <thead>
                <tr>
                  <th>Сортировка</th>
                  <th>ID</th>
                  <th>Название</th>
                  <th>Включен</th>
                  <th>Действия</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="onboarding in onboardings" :key="onboarding.id">
                  <td>{{ onboarding.sort }}</td>
                  <td>{{ onboarding.id }}</td>
                  <td>{{ onboarding.title }}</td>
                  <td>
                    <CSwitch
                        :checked.sync="onboarding.enabled"
                        color="success"
                        shape="pill"
                        variant="opposite"
                        @update:checked="toggleEnabled(onboarding)" />
                  </td>
                  <td>
                    <CButton
                      color="info"
                      size="sm"
                      @click="editOnboarding(onboarding.id)"
                    >
                      Редактировать
                    </CButton>
                    <CButton
                      color="danger"
                      size="sm"
                      @click="deleteOnboarding(onboarding.id)"
                    >
                      Удалить
                    </CButton>
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { CRow, CCol, CCard, CCardHeader, CCardBody, CButton, CSpinner, CSwitch } from '@coreui/vue';

export default {
  components: {
    CRow,
    CCol,
    CCard,
    CCardHeader,
    CCardBody,
    CButton,
    CSpinner,
    CSwitch,
  },
  data() {
    return {
      onboardings: [],
      loading: true,
    };
  },
  created() {
    this.fetchOnboardings();
  },
  methods: {
    async fetchOnboardings() {
      try {
        const response = await this.axios.get('/onboarding');
        this.onboardings = response.data;
      } catch (error) {
        this.$root.$emit('showError', 'Ошибка загрузки онбордингов.');
      } finally {
        this.loading = false;
      }
    },
    async toggleEnabled(onboarding) {
      try {
        await this.axios.put(`/onboarding/${onboarding.id}`, {
          enabled: onboarding.enabled,
        });
      } catch (error) {
        this.$root.$emit('showError', 'Ошибка обновления статуса.');
      }
    },
    editOnboarding(id) {
      this.$router.push(`/onboarding/${id}/edit`);
    },
    async deleteOnboarding(id) {
      if (confirm('Вы уверены, что хотите удалить этот онбординг?')) {
        try {
          await this.axios.delete(`/onboarding/${id}`);
          this.fetchOnboardings();
        } catch (error) {
          this.$root.$emit('showError', 'Ошибка удаления онбординга.');
        }
      }
    },
  },
};
</script>

<style scoped>
.table__preloader {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}
</style>
